// Copyright © 2021 Move Closer

import { ShareServiceConfig } from '@service/share'

export const shareServiceConfig: ShareServiceConfig = {
  facebook: {
    appId: process.env.VUE_APP_FACEBOOK_APP_ID || ''
  }
}
